import PropTypes from 'prop-types';
export const CollapsiblePropTypes = {
    /** Default state indicated collapsible opened */
    defaultExpanded: PropTypes.bool,
    /** Title  */
    title: PropTypes.string,
    /** Icon for title */
    titleImgComponent: PropTypes.elementType,
    /** Subtitle */
    subtitle: PropTypes.string,
    /** Indicates if the arrowIcon must be in left or right side */
    isReversed: PropTypes.bool,
    /** Applies or not the elevated styles for the container */
    isElevated: PropTypes.bool,
};
export const CollapsibleDefaultValues = {
    defaultExpanded: false,
    isReversed: false,
    isElevated: false,
};
//# sourceMappingURL=collapsible.prop-types.js.map